export default "__VITE_ASSET__D91ho3to__"